import { render, staticRenderFns } from "./add-details.vue?vue&type=template&id=eff06294&"
import script from "./add-details.ts?vue&type=script&lang=ts&"
export * from "./add-details.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports